import api from './client';

export const relationsApi = {
  search: (recordTypeId, q, excludeId) =>
    api.get('/relations/search', { params: { record_type_id: recordTypeId, q, exclude_id: excludeId } }).then(r => r.data),
  getForRecord: (recordId) =>
    api.get('/relations/record/' + recordId).then(r => r.data),
  create: (data) =>
    api.post('/relations', data).then(r => r.data),
  delete: (id) =>
    api.delete('/relations/' + id).then(r => r.data),
};
